var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelVine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.57 12.091c-1.973 0-3.493-1.41-3.493-3.861 0-1.202.454-1.827 1.097-1.827.61 0 1.018.561 1.018 1.699 0 .646-.17 1.355-.294 1.775 0 0 .608 1.085 2.271.752.353-.802.545-1.84.545-2.752C18.714 5.426 17.492 4 15.252 4c-2.302 0-3.65 1.81-3.65 4.198 0 2.365 1.081 4.395 2.864 5.32-.75 1.533-1.704 2.884-2.698 3.902-1.805-2.231-3.436-5.208-4.106-11.017H5c1.23 9.675 4.896 12.755 5.865 13.347.548.336 1.02.32 1.522.032.787-.458 3.15-2.875 4.46-5.705a8.6 8.6 0 0 0 1.867-.218v-1.905a5 5 0 0 1-1.143.137"
})));
export default SvgGemChannelVine;